import { Library, Languages, Book, Scroll } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';

interface AuthorVoiceCardProps {
    author: {
        style?: string;
        vocabulary?: string;
        languageSkill?: string;
    };
    isExpanded: boolean;
    onToggleExpansion: () => void;
    thumbnailUrl?: string;
}

export function AuthorVoiceCard({ author, isExpanded, onToggleExpansion, thumbnailUrl }: AuthorVoiceCardProps) {
    if (!author.style && !author.vocabulary && !author.languageSkill) return null;

    return (
        <DiscoveryCard
            isExpanded={isExpanded}
            onToggle={onToggleExpansion}
            icon={Library}
            thumbnailUrl={thumbnailUrl}
            header={
                <div className="flex flex-col gap-1">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/50">Stylistic Layer</div>
                    <h3 className="text-xl font-serif font-medium text-foreground/90 leading-tight">Author's Voice & Style</h3>
                </div>
            }
        >
            <div className="pt-4 space-y-6">
                {author.style && (
                    <div className="space-y-2">
                        <div className="flex items-center gap-2">
                            <div className="p-1 rounded bg-primary/5">
                                <Book className="h-3 w-3 text-primary/40" />
                            </div>
                            <span className="text-[10px] font-bold uppercase tracking-widest text-primary/40">Writing Style</span>
                        </div>
                        <p className="text-sm text-foreground/80 font-light leading-relaxed pl-3.5 border-l border-primary/10">
                            {author.style}
                        </p>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {author.vocabulary && (
                        <div className="space-y-2">
                            <div className="flex items-center gap-2">
                                <div className="p-1 rounded bg-primary/5">
                                    <Languages className="h-3 w-3 text-primary/40" />
                                </div>
                                <span className="text-[10px] font-bold uppercase tracking-widest text-primary/40">Vocabulary</span>
                            </div>
                            <p className="text-sm text-foreground/80 font-light leading-relaxed pl-3.5 border-l border-primary/10">
                                {author.vocabulary}
                            </p>
                        </div>
                    )}
                    {author.languageSkill && (
                        <div className="space-y-2">
                            <div className="flex items-center gap-2">
                                <div className="p-1 rounded bg-primary/5">
                                    <Scroll className="h-3 w-3 text-primary/40" />
                                </div>
                                <span className="text-[10px] font-bold uppercase tracking-widest text-primary/40">Language Skill</span>
                            </div>
                            <p className="text-sm text-foreground/80 font-light leading-relaxed pl-3.5 border-l border-primary/10">
                                {author.languageSkill}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </DiscoveryCard>
    );
}
